/** Core dependencies */
import React, { Component, useState } from 'react';


/** Third party dependencies */
import {
    IconButton,
    Tabs,
    Tab,
    Box,
    Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

/**
 * 
 * @param {Array<Component>} props.children 
 * @param {Number} props.value 
 * @returns 
 */
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
}

const TabsComponent = (props) => {
    const {
        tabState,
        tabDetails = [],
    } = props;

    const [tabValue, setTabValue] = tabState;


    useEffect(() => {
        const savedTabValue = localStorage.getItem('activeTab');
        if (savedTabValue !== null) {
            setTabValue(Number(savedTabValue));
        }
    }, [setTabValue]);

    useEffect(() => {
        localStorage.setItem('activeTab', tabValue);
    }, [tabValue]);


    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        localStorage.setItem('activeTab', newValue);
    };
    return (
        <div>
            <Box  display="flex"
      flexDirection="column"
  
      borderBottom='2px solid #2963AD !important'
             >
                <Tabs
                    value={tabValue}

                    onChange={handleTabChange}
                    aria-label="tabs-to-use"
                    TabIndicatorProps={{
                        style: { backgroundColor: '#2963AD',height:'50px',borderRadius:'10px 10px 0px 0px' }, // Active tab indicator
                      }}>
                    {
                        tabDetails
                            .map((tabDetail,index) => (
                            // <Tab label={tabDetail.label}  key={index}/>
                            <Tab
                            label={tabDetail.label}
                            key={index}
                            style={{
                                zIndex:10,
                                color: tabValue === index ? 'white' : 'gray', // Selected tab font color
                                fontWeight: tabValue === index ? 'normal' : 'normal', // Optional: Bold for selected tab
                            }}
                        />
                            ))
                    }
                </Tabs>
            </Box>
            {
                tabDetails
                    .map((tabDetail, index) => {
                        return (tabValue === index) && (
                            
                            <TabPanel  value={tabValue} index={index}>
                                {tabDetail.content}
                            </TabPanel>
                        );
                    })
            }
        </div>
    )
}

export default TabsComponent;
